import { render } from "./DynamicDataList.vue?vue&type=template&id=71ca6dfc"
import script from "./DynamicDataList.vue?vue&type=script&lang=js"
export * from "./DynamicDataList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__